import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {forkJoin, of, switchMap} from 'rxjs';
import {BaseDataService} from "./base-data.service";
import {OfferService} from "../../data/services/offer.service";
import {catchError, map} from "rxjs/operators";

/***
 * Ausgaben werden für das jeweilige Produkt (Angebot) im Local Storage zwischengespeichert, damit sie schneller erreichbar sind.
 * Bei Aufruf des Resolvers werden die Varianten-Codes des Angebots abgefragt und die zugehörigen Beschreibungen aus den Basisdaten geholt.
 * Diese werden dann im Local Storage unter dem Key "variants_[productCode]" als JSON-String abgelegt.
 ***/
export const editionResolverService: ResolveFn<void> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const offerService = inject(OfferService);
  const baseDataService = inject(BaseDataService);
  const offerId = route.params['offerId'];

  return offerService.getOfferDetail(offerId).pipe(
    switchMap(offer => {
      const variants: string[] = offer?.product?.variantCodeList ?? [];
      const productCode = offer?.product?.productCode;

      if (productCode && productCode != '' && variants.length > 0) {
        const calls = variants.map(v =>
          baseDataService.getVariantCode(v).pipe(
            catchError(() => of(null))
          )
        );

        return forkJoin(calls).pipe(
          map(results => {
            const variants = results
              .filter(vc => vc?.key && vc?.description)
              .map(vc => ({variantCode: vc.key, variantName: vc.description}));

            // z.B. variants_[productCode] = [{variantCode: 'V1', variantName: 'Variant 1'}, ...]
            localStorage.setItem('variants_' + productCode, JSON.stringify(variants));
            return void 0;
          })
        );
      }
    }),
    catchError(() => of(void 0)));
};
